const GetInventoryUIData = async () => {
  try {
    const response = await fetch(
      process.env.NODE_ENV === "production"
        ? "/ignitionapi/inventorytool/GetInventoryUIDetails"
        : "https://devfeature.legrandav.com/ignitionapi/inventorytool/GetInventoryUIDetails",
    );

    const data = await response.json();

    return data.InventoryUIDetails;
  } catch (error) {
    console.log(`GetInventoryUIData error: ${error}`);
  }
};

export default GetInventoryUIData;
